import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { Provider } from 'react-redux';
import { store, persistor } from './app/store';
import { validateSessionOnBoot } from './features/authSlice';
import { PersistGate } from 'redux-persist/integration/react';
import Spinner from './components/spinner/Spinner';
import { setupAxiosAuthInterceptors } from './utils/setupAxiosAuth';

setupAxiosAuthInterceptors(store);

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <PersistGate
        loading={<Spinner />}
        persistor={persistor}
        onBeforeLift={() => {
          store.dispatch(validateSessionOnBoot());
        }}
      >
        <App />
      </PersistGate>
    </Provider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
